import TipoContatoService from '../_services/TipoContatoService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { tipoContatoModel } from '../_model/tipoContato'

const state = {
  loading: false,
  loadingStore: false,
  dropdownTipoContato: [],
  tipoContatos: [],
  tipoContatoSelecionado: undefined,
  erros: '',

}

const getters = {
  GET_TIPOCONTATOS : (state) => state.tipoContatos,
  GET_DROPDOWN: state => state.dropdownTipoContato,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  TIPOCONTATO_SELECTED : (state, { tipoContato }) => {
    state.tipoContatoSelecionado = Object.assign({}, tipoContato)
  },

  SET_TIPOCONTATOS : (state, { tipoContatos }) => {
    state.tipoContatos = JSON.parse(JSON.stringify(tipoContatos))
  },

  SET_DROPDOWN : (state, tipoContatos) => {
    state.dropdownTipoContato = JSON.parse(JSON.stringify(tipoContatos))
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.tipoContatoSelecionado = undefined,

}

const actions = {

  LOAD_DROPDOWN : async ({commit}) => {
    commit('SET_DROPDOWN', [])
    commit('ERASE_ERROS')
    await TipoContatoService.getDropDown()
    .then(response => {
      if (response.data.status) {
        var drop = []
        var obj = response.data.tipocontatos
        Object.keys(obj).forEach(function (item) {
          var array = { value: obj[item].id, text: obj[item].descricao}
          drop.push(array)
        })
        commit('SET_DROPDOWN', drop)

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_TIPOCONTATOS : async ({ commit }) => {
      commit('SET_TIPOCONTATOS', { tipoContatos : []})
      commit('ERASE_ERROS')
      await TipoContatoService.getTipoContatos()
      .then(response => {
        if (response.data.status) {
          commit('SET_TIPOCONTATOS', { tipoContatos : response.data.tipocontatos })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
  },

  GET_TIPOCONTATO : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await TipoContatoService.getTipoContato(id)
    .then(response => {
      if (response.data.status) {
        commit('TIPOCONTATO_SELECTED', { tipoContato : response.data.tipocontato })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  STORE_TIPOCONTATO : async ({ commit, dispatch }, tipoContato) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!tipoContato.id || !(tipoContato.id > 0)) { 
        var response = await TipoContatoService.postTipoContato(tipoContato)
      } else {
        var response = await TipoContatoService.putTipoContato(tipoContato.id, tipoContato)
      }

      if (response.data.status) {
        commit('TIPOCONTATO_SELECTED', { tipoContato : response.data.tipoacionado })
          await dispatch('GET_TIPOCONTATOS')

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_TIPOCONTATO : async ({ commit, dispatch }, tipocontato) => {
    commit('ERASE_ERROS')
    try {
      var response = await TipoContatoService.deleteTipoContato(tipocontato.id)

      if (response.data.status) {
        await dispatch('GET_TIPOCONTATOS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  TIPOCONTATO_SELECTED : async ({dispatch, commit}, id) => {
    if (id > 0) { 
      await dispatch('GET_TIPOCONTATO', id)
    } else {
      var obj = new tipoContatoModel.tipoContato()
      await commit('TIPOCONTATO_SELECTED', { tipoContato: obj })
    }
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/TipoContato/_store/index.js